export default "__VITE_ASSET__Bzu6gdZi__"